import { useRef } from 'react';
import useEventListener from 'components/shared/hooks/useEventListener';

const SCROLL_OFFSET = 20;

const scrollDown = () => {
  const nextScrollTop = document.documentElement.scrollTop + SCROLL_OFFSET;
  window.scrollTo(0, nextScrollTop);
};
const scrollUp = () => {
  const nextScrollTop = document.documentElement.scrollTop - SCROLL_OFFSET;

  if (nextScrollTop >= 0) {
    window.scrollTo(0, nextScrollTop);
  }
};

const useSmoothScroll = () => {
  const data = useRef();

  const updateData = clientY => {
    data.current = {
      isDragging: true,
      lastMouseClientY: clientY,
    };
  };

  useEventListener('dragover', e => updateData(e.clientY));
  useEventListener('touchmove', e => updateData(e.changedTouches[0].clientY));

  const smoothscroll = () => {
    const { isDragging, lastMouseClientY } = data.current;

    if (isDragging) {
      if (lastMouseClientY !== undefined) {
        if (lastMouseClientY > window.innerHeight - 50) {
          scrollDown();
        } else if (lastMouseClientY < 50) {
          scrollUp();
        }
      }
      window.requestAnimationFrame(smoothscroll);
    }
  };

  const onDragStart = () => {
    data.current = {
      isDragging: true,
      lastMouseClientY: undefined,
    };
    smoothscroll();
  };
  const onDragEnd = () => {
    data.current = {
      isDragging: false,
      lastMouseClientY: undefined,
    };
  };

  return { onDragStart, onDragEnd };
};

export default useSmoothScroll;
